import './partials/polyfill';

const $form = document.querySelector('.cancel-subscription-form');

if ($form) {
  const $spinner = $form.querySelector('.spinner');
  const $button = $form.querySelector('.btn');

  $form.addEventListener('submit', (event) => {
    event.preventDefault();

    if ($button) {
      $button.remove();
    }

    if ($spinner) {
      $spinner.style.display = 'block';
    }

    fetch($form.action, {
      method: $form.method,
      body: new FormData($form),
      cache: 'no-cache',
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && data.message) {
          $form.outerHTML = data.message;
        }
      });
  });
}
